'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var crypto = require('./crypto');

var lp = require('it-length-prefixed');

var int32BEEncode = lp.int32BEEncode;

var debug = require('debug');

var log = debug('libp2p:secio');
log.error = debug('libp2p:secio:error'); // step 1. Propose
// -- propose cipher suite + send pubkeys + nonce

module.exports = /*#__PURE__*/function () {
  var _propose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, wrapped) {
    var prop, msg;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log('1. propose - start');
            prop = crypto.createProposal(state);
            log('1. propose - writing proposal', prop);
            _context.next = 5;
            return wrapped.write(lp.encode.single(prop, {
              lengthEncoder: int32BEEncode
            }));

          case 5:
            log('1. propose - reading proposal');
            _context.next = 8;
            return wrapped.readLP();

          case 8:
            msg = _context.sent.slice();
            log('1. propose - read proposal', msg);
            _context.next = 12;
            return crypto.identify(state, msg);

          case 12:
            _context.next = 14;
            return crypto.selectProtocols(state);

          case 14:
            log('1. propose - finish');

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function propose(_x, _x2) {
    return _propose.apply(this, arguments);
  }

  return propose;
}();